/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { toast } from "react-toastify";
import { CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { Card } from "@material-ui/core";
import { Link, Redirect } from "react-router-dom";

const PaymentSuccess = () => {
  const context = useContext(UserContext);
  const [receptdata , setreceptdata ] = useState([]);
  const [action , setaction ] = useState(false);
  useEffect(() => {
    getpaymentreceipt();
  },[]);
  const getpaymentreceipt=async () =>{
    let formData = new FormData();
    formData.append("orderid", localStorage.getItem("encordertoken"));
    axios
      .post("Payment/getPaymentReceipt", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          console.log(res)
          // this.setState({ receptdata: res.data });
          setreceptdata(res.data)
          if(res.data.statuscode==="Success")
          {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("usertype", res.data.ut);
            localStorage.setItem("name", res.data.name);
            localStorage.setItem("initial",  res.data.initial);
            // localStorage.setItem("data",  JSON.stringify(res.data.mydata));
            localStorage.setItem("user",  res.data.user);
            context.setUser({ email: res.data.user, token: res.data.token })
             setaction(true)
            toast.success("Your Transaction is successfull!!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 10000,
          });
        }
        else{
          toast.error("Your Transaction is failed contact admin!!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 10000,
          });
        }
         // console.log(this.state.receptdata);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  if(!context.user?.email && action)
  {
    return <Redirect to="/Signin" />;
  }
  return (
    <div>
        <br />
        <br />
        <br />
        <br />
        <section className="padding-default">
          <Row>
            <Col sm={12}>
              <Link to="/">
                {" "}
                <button class="btn_1 rounded">
                  Click here to start your Course
                </button>{" "}
              </Link>
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={12}>
              <Card>
                <CardHeader>
                  <div class="row">
                    <div class="col-lg-6" style={{ textAlign: "left" }}>
                      Payment Receipt{" "}
                    </div>
                    <div class="col-lg-6" style={{ textAlign: "right" }}>
                    <a
                    href={receptdata.path}
                    target="_blank"
                    download
                    rel="noreferrer"
                  >
                    <button class="btn_1 rounded">Download Receipt</button>
                  </a>
                    </div>
                  </div>
                  
                </CardHeader>
                <CardBody>
                  <div class="row">
                    <div class="col-lg-6" style={{ textAlign: "left" }}>
                      To,
                      <br />
                      {receptdata.name}
                      <br />
                      {receptdata.uid}
                      <br />
                      Date:{receptdata.Date}
                      <br />
                      Order Id:{receptdata.orderid}
                      <br />
                      Transaction Id:{receptdata.tid}
                      <br />
                      Status:{receptdata.statuscode}
                      <br />
                    </div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-3">
                      Udnav Erp Software Technologies Llp.
                      <br />
                      <address style={{ "font-size": "12px" }}>
                         School Building S. No. 201/5/6B 9A/3P , GPawar Public School Street, Pune
                       Maharashtra 411 028, India.
                      </address>
                      GST: 27AAIFU4597J1ZF
                      <br />
                      <p> PAN: AAIFU4597J </p>
                      <br />
                    </div>
                  </div>
                  <div class="row"></div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Course</th>
                        <th>Course Id </th>
                        <th>Payment Mode </th>
                        <th>Coupon (if any) </th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{receptdata.course}</td>
                        <td>{receptdata.courseid}</td>
                        <td>{receptdata.paymentmode}</td>
                        <td>{receptdata.promocode}</td>
                        <td>{receptdata.amount}</td>
                      </tr>
                      <tr>
                        <td colspan="4"></td>
                        <td>
                          Base price: Rs {receptdata.base_price} /-
                        </td>
                      </tr>
                      <tr style={{ textAlign: "left" }}>
                        <td colspan="4"></td>
                        <td> 
                          Discounted amount: Rs{" "}
                          {receptdata.discountedprice} /-
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4"></td>
                        <td>GST : {receptdata.gst} /-</td>
                      </tr>
                      <tr>
                        <th colspan="4"></th>
                        <td>
                          {" "}
                          <b>Total Rs :{receptdata.amount} /-</b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </section>
      </div>
  );
};

export default PaymentSuccess;